module.exports = __webpack_public_path__ + "img/49.dece1286.jpg";